import React, { useState, useEffect } from 'react';

import axios from 'axios';
import './css/register.css';
import { useHistory } from 'react-router-dom';
import { Form, Button, Badge, Modal, Table } from 'react-bootstrap';
import noHPKades from '../../assets/JsonData/NoHPKades.json';
import noHPCamat from '../../assets/JsonData/NoHPCamat.json';
import noHPBidan from '../../assets/JsonData/noHpBidan.json';
import desaKecamatan from '../../assets/JsonData/Puskes_Desa.json';
import ReactHTMLTableToExcel from 'react-html-table-to-excel';
import { API_MAMABOI } from '../../utils/constant';

import LoadDataPesanTidakBerkunjung from '../task/LoadDataPesanTidakBerkunjung';

const Pesan40Hari = ({ data, nama }) => {
  const [access, setAccess] = useState('');
  const history = useHistory();
  const [pesanDialog, setPesanDialog] = useState('');
  const [show, setShow] = useState(false);
  const handleClose = () => setShow(false);
  const [checked, setChecked] = useState([]);
  const [dataTidakKunjung, setDataTidakKunjung] = useState([]);

  const handleShow = () => {
    if (checked.length === 0) {
      return;
    }
    setPesanDialog(
      'Apakah anda akan mengirimkan pesan untuk Ibu yang 40 Hari tidak berkunjung kepada ' +
        checked +
        ' ?'
    );
    setShow(true);
  };

  const load = () => {
    const LoadDataHpTdk = new LoadDataPesanTidakBerkunjung();
    LoadDataHpTdk.load(setDataTidakKunjung, data);
  };

  useEffect(() => {
    load();
  }, [data]);

  const changeCheck = (event) => {
    var updatedList = [...checked];
    if (event.target.checked) {
      updatedList = [...checked, event.target.value];
    } else {
      updatedList.splice(checked.indexOf(event.target.value), 1);
    }
    setChecked(updatedList);
  };

  const savePesan = async (jenis, tujuan, sender) => {
    //'https://test.mamaboi.net/api/users/login',

    var dateObj = new Date();
    var month = dateObj.getUTCMonth() + 1; //months from 1-12
    var day = dateObj.getUTCDate();
    var year = dateObj.getUTCFullYear();
    var hour = dateObj.getUTCHours();
    var minutes = dateObj.getUTCMinutes();
    var seconds = dateObj.getUTCSeconds();
    var newdate = year + '-' + month + '-' + day;
    var newdatetime =
      year +
      '-' +
      month +
      '-' +
      day +
      ' ' +
      hour +
      ':' +
      minutes +
      ':' +
      seconds;
    //

    var pesan = '40 Hari tidak melakukan perkunjungan';
    try {
      const response = await axios.post(API_MAMABOI + 'pesan', {
        tanggal: newdatetime,
        jenis: jenis,
        tujuan: tujuan,
        pesan: pesan,
        sender: sender,
      });
    } catch (error) {
      if (error.response) {
        //setMsg(error.response.data.msg);
      }
    }
  };

  function kirimPesan() {
    var url = 'https://pati.wablas.com/api/send-message';
    var Tokenwhatsap =
      'IONVgbV7rm3bzVoDI4jjm9zRFwDmA6j1AzgzTDkjDAQBPgNSf1CTSZ3AtORKVfls';
    var nohp = '082237839018';
    //'081239619532'
    //082237839018
    var i = 0;

    checked.map((r) => {
      var kop = `📢 *MAMA BO'I INFO 40 HARI TIDAK KUNJUNG*📢  \n\ \n\ `;
      if (r == 'Ibu Hamil') {
        for (var i = 0; i < dataTidakKunjung.length; i++) {
          if (dataTidakKunjung[i].hp !== '' || dataTidakKunjung[i].hp !== '0') {
            var pesanKu =
              `Soda Molek Ibu *` +
              dataTidakKunjung[i].namaIbu +
              `*` +
              `\n\ \n\Data kami menunjukan bahwa Ibu sudah lebih 40 hari tidak melakukan pemeriksaan ke fasilitas kesehatan ` +
              `\n\ \n\Mohon segera mengunjungi Puskesmas/Pustu terdekat untuk memeriksaan kehamilannya`;
            var data = {
              phone: dataTidakKunjung[i].hp,
              message:
                kop + pesanKu + `\n\ \n\ 🙏🙏🙏 \n\ Sekretariat Mama Bo'i`,
            };

            var options_user = {
              method: 'POST',
              headers: {
                Authorization: Tokenwhatsap,
                'Content-Type': 'application/json',
              },
              body: JSON.stringify(data),
            };

            var response = fetch(url, options_user).then((response) =>
              response.text()
            );
          }
        }
      }

      if (r == 'Kepala Desa') {
        for (var i = 0; i < dataTidakKunjung.length; i++) {
          var desa = dataTidakKunjung[i].desa;
          var hpKades = noHPKades.filter((rr) => {
            return rr.desa == desa;
          });

          if (hpKades.length > 0) {
            var pesanKu =
              `Soda Molek Bapa Desa *` +
              desa +
              `*` +
              `\n\Salah satu warga Bapak yang berstatus Ibu Hamil` +
              `\n\Nama  : *` +
              dataTidakKunjung[i].namaIbu +
              `* \n\Jangka waktu tidak berkunjung  : *` +
              dataTidakKunjung[i].jarakKunjung +
              `* hari` +
              `\n\No HP  : ` +
              dataTidakKunjung[i].hp +
              ` \n\ \n\Mohon bantuanya utk memfasilitasi Ibu tersebut agar dapat berkunjung ke Fasilitas Kesehatan untuk memeriksaan kehamilannya`;
            var data = {
              phone: hpKades[0].noHp,
              message:
                kop + pesanKu + `\n\ \n\ 🙏🙏🙏 \n\ Sekretariat Mama Bo'i`,
            };

            var options_user = {
              method: 'POST',
              headers: {
                Authorization: Tokenwhatsap,
                'Content-Type': 'application/json',
              },
              body: JSON.stringify(data),
            };

            var response = fetch(url, options_user).then((response) =>
              response.text()
            );
          }
        }
      }
      if (r == 'Camat') {
        for (var i = 0; i < dataTidakKunjung.length; i++) {
          var desa = dataTidakKunjung[i].desa;
          var cariCamat = [];
          var cari = desaKecamatan.filter((rr) => {
            return rr.Desa == desa;
          });

          if (cari.length !== 0) {
            cariCamat = noHPCamat.filter((rr) => {
              return rr.kecamatan == cari[0].Kecamatan;
            });
          }

          if (cariCamat.length !== 0) {
            var pesanKu =
              `Soda Molek Bapa Camat *` +
              cariCamat[0].kecamatan +
              `*` +
              `\n\Salah satu warga Bapak yang berstatus Ibu Hamil` +
              `\n\Nama  : *` +
              dataTidakKunjung[i].namaIbu +
              `*` +
              `\n\Desa  : *` +
              dataTidakKunjung[i].desa +
              `* \n\Jangka waktu tidak berkunjung  : *` +
              dataTidakKunjung[i].jarakKunjung +
              `* hari` +
              `\n\No HP  : ` +
              dataTidakKunjung[i].hp +
              ` \n\ \n\Mohon bantuanya utk memfasilitasi Ibu tersebut agar dapat berkunjung ke Fasilitas Kesehatan untuk memeriksaan kehamilannya`;
            var data = {
              phone: cariCamat[0].noHp,
              message:
                kop + pesanKu + `\n\ \n\ 🙏🙏🙏 \n\ Sekretariat Mama Bo'i`,
            };

            var options_user = {
              method: 'POST',
              headers: {
                Authorization: Tokenwhatsap,
                'Content-Type': 'application/json',
              },
              body: JSON.stringify(data),
            };

            var response = fetch(url, options_user)
              .then((response) => response.text())
              .then((data) => console.log(data));
          }
        }
      }
      if (r == 'Bidan') {
        for (var i = 0; i < dataTidakKunjung.length; i++) {
          if (dataTidakKunjung[i].noHpBidan !== '') {
            var pesanKu =
              `Soda Molek Bidan *` +
              dataTidakKunjung[i].bidan +
              `*` +
              `\n\Salah satu pasien Ibu` +
              `\n\Nama  : *` +
              dataTidakKunjung[i].namaIbu +
              `* \n\Jangka waktu tidak berkunjung  : *` +
              dataTidakKunjung[i].jarakKunjung +
              `* hari` +
              `\n\No HP  : ` +
              dataTidakKunjung[i].hp +
              ` \n\ \n\Mohon bantuanya utk memfasilitasi Ibu tersebut agar dapat berkunjung ke Fasilitas Kesehatan untuk memeriksaan kehamilannya`;
            var data = {
              phone: dataTidakKunjung[i].noHpBidan,
              message:
                kop + pesanKu + `\n\ \n\ 🙏🙏🙏 \n\ Sekretariat Mama Bo'i`,
            };

            var options_user = {
              method: 'POST',
              headers: {
                Authorization: Tokenwhatsap,
                'Content-Type': 'application/json',
              },
              body: JSON.stringify(data),
            };

            var response = fetch(url, options_user).then((response) =>
              response.text()
            );
          }
        }
      }
      if (r == 'Suami') {
        for (var i = 0; i < dataTidakKunjung.length; i++) {
          if (
            dataTidakKunjung[i].hpSuami !== '' ||
            dataTidakKunjung[i].hpSuami !== '0'
          ) {
            var pesanKu =
              `Soda Molek Bapak *` +
              dataTidakKunjung[i].suami +
              '*' +
              `\n\Data kami menunjukan Ibu` +
              `\n\Nama  : *` +
              dataTidakKunjung[i].namaIbu +
              `* \n\Jangka waktu tidak berkunjung  : *` +
              dataTidakKunjung[i].jarakKunjung +
              `* hari` +
              `\n\No HP  : ` +
              dataTidakKunjung[i].hp +
              ` \n\ \n\Mohon bantuanya utk memfasilitasi Ibu tersebut agar dapat berkunjung ke Fasilitas Kesehatan untuk memeriksaan kehamilannya`;
            var data = {
              phone: dataTidakKunjung[i].hpSuami,
              message:
                kop + pesanKu + `\n\ \n\ 🙏🙏🙏 \n\ Sekretariat Mama Bo'i`,
            };

            var options_user = {
              method: 'POST',
              headers: {
                Authorization: Tokenwhatsap,
                'Content-Type': 'application/json',
              },
              body: JSON.stringify(data),
            };

            var response = fetch(url, options_user).then((response) =>
              response.text()
            );
          }
        }
      }
      if (r == 'Tokoh Agama') {
        for (var i = 0; i < dataTidakKunjung.length; i++) {
          if (
            dataTidakKunjung[i].nomorTA !== '' ||
            dataTidakKunjung[i].nomorTA !== '0'
          ) {
            var pesanKu =
              `Soda Molek Bapak/Ibu *` +
              dataTidakKunjung[i].namaTA +
              '*' +
              `\n\Data kami menunjukan Ibu` +
              `\n\Nama  : *` +
              dataTidakKunjung[i].namaIbu +
              `* \n\Jangka waktu tidak berkunjung  : *` +
              dataTidakKunjung[i].jarakKunjung +
              `* hari` +
              `\n\No HP  : ` +
              dataTidakKunjung[i].hp +
              ` \n\ \n\Mohon bantuanya utk memfasilitasi Ibu tersebut agar dapat berkunjung ke Fasilitas Kesehatan untuk memeriksaan kehamilannya`;
            var data = {
              phone: dataTidakKunjung[i].nomorTA,
              message:
                kop + pesanKu + `\n\ \n\ 🙏🙏🙏 \n\ Sekretariat Mama Bo'i`,
            };

            var options_user = {
              method: 'POST',
              headers: {
                Authorization: Tokenwhatsap,
                'Content-Type': 'application/json',
              },
              body: JSON.stringify(data),
            };

            var response = fetch(url, options_user).then((response) =>
              response.text()
            );
          }
        }
      }
      if (r == 'Tokoh Budaya') {
        for (var i = 0; i < dataTidakKunjung.length; i++) {
          if (
            dataTidakKunjung[i].nomorTB !== '' ||
            dataTidakKunjung[i].nomorTB !== '0'
          ) {
            var pesanKu =
              `Soda Molek Bapak/Ibu *` +
              dataTidakKunjung[i].namaTB +
              '*' +
              `\n\Data kami menunjukan Ibu` +
              `\n\Nama  : *` +
              dataTidakKunjung[i].namaIbu +
              `* \n\Jangka waktu tidak berkunjung  : *` +
              dataTidakKunjung[i].jarakKunjung +
              `* hari` +
              `\n\No HP  : ` +
              dataTidakKunjung[i].hp +
              ` \n\ \n\Mohon bantuanya utk memfasilitasi Ibu tersebut agar dapat berkunjung ke Fasilitas Kesehatan untuk memeriksaan kehamilannya`;
            var data = {
              phone: dataTidakKunjung[i].nomorTB,
              message:
                kop + pesanKu + `\n\ \n\ 🙏🙏🙏 \n\ Sekretariat Mama Bo'i`,
            };

            var options_user = {
              method: 'POST',
              headers: {
                Authorization: Tokenwhatsap,
                'Content-Type': 'application/json',
              },
              body: JSON.stringify(data),
            };

            var response = fetch(url, options_user).then((response) =>
              response.text()
            );
          }
        }
      }

      if (r == 'Kader') {
        for (var i = 0; i < dataTidakKunjung.length; i++) {
          if (
            dataTidakKunjung[i].nomorKader !== '' ||
            dataTidakKunjung[i].nomorKader !== '0'
          ) {
            var pesanKu =
              `Soda Molek Bapak/Ibu *` +
              dataTidakKunjung[i].namaKader +
              '*' +
              `\n\Data kami menunjukan Ibu` +
              `\n\Nama  : *` +
              dataTidakKunjung[i].namaIbu +
              `* \n\Jangka waktu tidak berkunjung  : *` +
              dataTidakKunjung[i].jarakKunjung +
              `* hari` +
              `\n\No HP  : ` +
              dataTidakKunjung[i].hp +
              ` \n\ \n\Mohon bantuanya utk memfasilitasi Ibu tersebut agar dapat berkunjung ke Fasilitas Kesehatan untuk memeriksaan kehamilannya`;
            var data = {
              phone: dataTidakKunjung[i].nomorKader,
              message:
                kop + pesanKu + `\n\ \n\ 🙏🙏🙏 \n\ Sekretariat Mama Bo'i`,
            };

            var options_user = {
              method: 'POST',
              headers: {
                Authorization: Tokenwhatsap,
                'Content-Type': 'application/json',
              },
              body: JSON.stringify(data),
            };

            var response = fetch(url, options_user).then((response) =>
              response.text()
            );
          }
        }
      }
    });
    setShow(false);
    var jenis = 'Pesan 40 Hari Tidak Berkunjung';
    var tujuan = checked;
    var sender = nama;
    savePesan(jenis, tujuan, sender);
    alert('pesan terkirim untuk ' + checked);
    history.push('/layout');
    history.push('/layout/pesan40hari');
  }

  return (
    <div>
      <div className='details'>
        <div>
          <div className='recentCustomers'>
            <div className='cardHeader'>
              <h2 color='Blue' margin='2rem'>
                Tidak Berkunjung dalam 40 Hari Terakhir{' '}
                <Badge bg='danger'>{dataTidakKunjung.length}</Badge>
              </h2>

              <ReactHTMLTableToExcel
                className='btn'
                table='dataIbu'
                filename='40 hari tidak berkunjung'
                sheet='tidak berkunjung'
                buttonText='Export to Exl'
              />
            </div>
            <div className='table-wrapper'>
              <Table id='dataIbu' striped bordered hover size='sm'>
                <thead color='blue'>
                  <tr>
                    <th>Profil</th>
                    <th>Nama</th>
                    <th>Puskesmas</th>
                    <th>Kunjung Terakhir</th>
                    <th>Desa</th>
                    <th>No Hp</th>
                    <th>Status</th>
                  </tr>
                </thead>
                {dataTidakKunjung.map((r, index) => (
                  <tr key={index}>
                    <td width='60px'>
                      <div className='imgBx'>
                        <img src={r.foto} alt='' />
                      </div>
                    </td>
                    <td>
                      <h4>
                        {r.namaIbu} <br />
                      </h4>
                    </td>
                    <td>
                      <span>{r.puskesmas}</span>
                    </td>
                    <td>
                      <span>{r.jarakKunjung + ' hari'}</span>
                    </td>
                    <td>
                      <span>{r.desa}</span>
                    </td>
                    <td>
                      <span>{r.hp}</span>
                    </td>
                    <td className={r.status}>
                      <span>{r.status}</span>
                    </td>
                  </tr>
                ))}
              </Table>
            </div>
          </div>
        </div>
        <Form>
          <h2>Sio Sodak</h2>
          <Form.Check
            type='switch'
            id='custom-switch1'
            label='Kepala Desa'
            class='form-check-input'
            onChange={changeCheck}
            value='Kepala Desa'
          />
          <Form.Check
            type='switch'
            id='custom-switch2'
            label='Camat'
            class='form-check-input'
            onChange={changeCheck}
            value='Camat'
          />
          <Form.Check
            type='switch'
            id='custom-switch3'
            label='Ibu Hamil'
            class='form-check-input'
            onChange={changeCheck}
            value='Ibu Hamil'
          />

          <Form.Check
            type='switch'
            id='custom-switch5'
            label='Tokoh Agama'
            class='form-check-input'
            onChange={changeCheck}
            value='Pendeta'
          />
          <Form.Check
            type='switch'
            id='custom-switch6'
            label='Tokoh Budaya'
            class='form-check-input'
            onChange={changeCheck}
            value='Tokoh Budaya'
          />
          <Form.Check
            type='switch'
            id='custom-switch7'
            label='Kader'
            class='form-check-input'
            onChange={changeCheck}
            value='Kader'
          />
          <Form.Check
            type='switch'
            id='custom-switch8'
            label='Bidan'
            class='form-check-input'
            onChange={changeCheck}
            value='Bidan'
          />
          <Form.Check
            type='switch'
            id='custom-switch9'
            label='Suami'
            class='form-check-input'
            onChange={changeCheck}
            value='Suami'
          />
          <div className='buttonBox'>
            <Button variant='primary' onClick={handleShow}>
              Kirim pesan <Badge bg='secondary'>40</Badge>
              <span className='visually-hidden'>unread messages</span>
            </Button>
          </div>
        </Form>
      </div>
      <Modal show={show} onHide={handleClose}>
        <Modal.Header closeButton>
          <Modal.Title>Pesan</Modal.Title>
        </Modal.Header>
        <Modal.Body>{pesanDialog}</Modal.Body>
        <Modal.Footer>
          <Button variant='secondary' onClick={handleClose}>
            Close
          </Button>
          <Button variant='primary' onClick={kirimPesan}>
            Send
          </Button>
        </Modal.Footer>
      </Modal>
    </div>
  );
};

export default Pesan40Hari;
